import { FC } from 'react'
import DownloadShipmentSourceFiles from '../../../../../components/buttons/download-shipment-source-files/download-shipment-source-files'
import Task from '../../../../../types/api/task'

interface SourceFileProps {
    task: Task
}

const SourceFile: FC<SourceFileProps> = ({ task }) => {
    return (
        <DownloadShipmentSourceFiles
            shipmentDocumentId={task.shipment?.documentId ?? ''}
            buttonProps={{ children: 'Скачать' }}
        />
    )
}

export default SourceFile
